import { Container, Row, Col, Table } from 'react-bootstrap';
import React, { Component } from 'react';
import Card from '../../components/Card/Card.jsx';
import axios from 'axios';

class internData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      aData: '',
      data: '',
      comment: '',
    };
    this.downloadFileObject = this.downloadFileObject.bind(this);
  }

  downloadFileObject(base64String, fileName) {
    const linkSource = base64String;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName + '.pdf';
    downloadLink.click();
  }

  async componentDidMount() {
    if (this.props.match.params._id) {
      // get users admissionApplication 
      await axios.post(`/api/adminApi/retriveApplicationData`, { 'internId': this.props.match.params._id })
        .then(response => {
          this.setState({ aData: response.data })
          this.printPdf(this.props.match.params._id, this.state.aData?.firstAndLastName)
        })
        .catch(err => {
          console.log(err)
        })
    }
  }

  downloadInternDV() {
    const downloadFileObject = (base64String) => {
      const linkSource = base64String;
      const downloadLink = document.createElement("a");
      const fileName = this.state.aData?.firstAndLastName + ".pdf";
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    }
    const downloadAsPdf = () => {
      let base64String = this.state.aData?.file;
      if (base64String.startsWith("JVB")) {
        base64String = "data:application/pdf;base64," + base64String;
        downloadFileObject(base64String);
      } else if (base64String.startsWith("data:application/pdf;base64")) {
        downloadFileObject(base64String);
      } else {
        alert("Greska");
      }
    }
    downloadAsPdf();
  }


  render() {
    return (
      <Container fluid >
        <Row className='justify-content-center'>
          <Col md={8}>
            <Card
              title="Preuzimanje CV kandidata (ako ga je poslao)"
              content={
                <Row className='justify-content-center'>
                  <Col md={2}>
                    <button className="btn btn-primary btn-fill" type="submit" onClick={this.downloadInternDV.bind(this)}>Preuzmi CV</button>
                  </Col>
                </Row>
              } />
          </Col>
        </Row>
        <Row className='justify-content-center'>
          <Col>
            <Table striped bordered hover>
              <tbody>
                <tr>
                  <td style={{ width: '50%' }}>Pozicija za koju konkurišete:</td>
                  <td>{this.state.aData?.position}</td>
                </tr>
                <tr>
                  <td>Prezime i ime:</td>
                  <td>{this.state.aData?.firstAndLastName}</td>
                </tr>
                <tr>
                  <td>Datum rođenja:</td>
                  <td>{this.state.aData?.birthDate}</td>
                </tr>
                <tr>
                  <td>Adresa prebivališta:</td>
                  <td>{this.state.aData?.address}</td>
                </tr>
                <tr>
                  <td>Grad prebivališta:</td>
                  <td>{this.state.aData?.city}</td>
                </tr>
                <tr>
                  <td>Država prebivališta:</td>
                  <td>{this.state.aData?.country}</td>
                </tr>
                <tr>
                  <td>Broj telefona:</td>
                  <td>{this.state.aData?.phoneNumber}</td>
                </tr>
                <tr>
                  <td>E-mail adresa:</td>
                  <td>{this.state.aData?.email}</td>
                </tr>
                <tr>
                  <td>Obrazovanje (vrsta stručne spreme):</td>
                  <td>{this.state.aData?.education}</td>
                </tr>
                <tr>
                  <td>Stepen stručne spreme:</td>
                  <td>{this.state.aData?.qualificationLevel}</td>
                </tr>
                <tr>
                  <td>Mogući datum stupanja na novo radno mesto:</td>
                  <td>{this.state.aData?.possibleFirstDayOnJob}</td>
                </tr>
                <tr>
                  <td>Očekivana plata na početku:</td>
                  <td>{this.state.aData?.expectedPay}</td>
                </tr>
                <tr>
                  <td>Očekivana plata nakon obuke:</td>
                  <td>{this.state.aData?.expectedPayAfterTraining}</td>
                </tr>
                <tr>
                  <td>Koja su Vaša očekivanja od kompanije i pozicije za koju konkurišete?</td>
                  <td>{this.state.aData?.expectation}</td>
                </tr>
                <tr>
                  <td>Koji je Vaš stav o kompaniji GALEB? </td>
                  <td>{this.state.aData?.whatYaThinkBoutGaleb}</td>
                </tr>
                <tr>
                  <td>Ukoliko neko može dati preporuku za Vas, molimo Vas da navedete ime, prezime i broj telefona te osobe: </td>
                  <td>{this.state.aData?.recomendation}</td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default internData;
